<template>
    <div id="Strategy">
        <!--        <nav>-->
        <!--            <div class="nav-box">-->
        <!--                <div-->
        <!--                    v-for="(item, index) of navList"-->
        <!--                    :key="index"-->
        <!--                    :class="`nav-item ${index === focusIndex ? 'nav-item-focus' : null}`"-->
        <!--                    @click="changeNav(item, index)">-->
        <!--                    <span>{{item.name}}</span>-->
        <!--                    <span v-show="index != navList.length - 1">|</span>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </nav>-->
        <div class="strategy-content">
            <div
                class="strategy-item"
                v-for="(item, index) of dataList"
                @click="toSeeDetails(item)"
                :key="index">
                <div class="strategy-banner">
                    <img :src="item.imgUrl" alt="">
                </div>
                <div class="strategy-info">
                    <div class="strategy-info-content">{{item.title}}</div>
                    <div>
                        <span>
                            <img src="../../assets/img/阅读量.png" alt="">
                            {{item.see}}
                        </span>
                        <span>
                            <img src="../../assets/img/点赞小.png" alt="">
                            {{item.comment}}
                        </span>
                    </div>
                    <div class="divider"></div>
                    <!--<div class="strategy-user">-->
                    <!--    <el-avatar :size="28" :src="item.head" :fit="`contain`"></el-avatar>-->
                    <!--    <span>{{item.name}}</span>-->
                    <!--</div>-->
                </div>
            </div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    @current-change="currentChange"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Strategy',
        data() {
            return {
                navList: [
                    {name: '全部主题'},
                    {name: '新鲜热门'},
                    {name: '安全知识'},
                    {name: '新手入门'}
                ],
                focusIndex: 0,
                dataList: [],
                pageNum: '1',
                pageSize: '20',
                type: '',
                total: 1
            }
        },
        methods: {
            // 切换nav
            changeNav(item, index) {
                this.focusIndex = index
            },
            /**
             * 获得数据列表
             */
            getList() {
                // this.$common.postMock('/strategyList').then(res => {
                //     console.log(res)
                //     this.dataList = res.data
                // })
                this.$common.querystringifyPost('/hdweb/portal/getPosting', {
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    type: this.type
                }).then(res => {
                    console.log(res)
                    this.dataList = res.data.rows
                    this.total = res.data.total
                })
            },
            /**
             * 当前页面
             */
            currentChange(pageNum) {
                console.log(pageNum)
                this.form.pageNum = pageNum
                this.getList()
            },
            /**
             * 跳转宣传信息
             */
            toSeeDetails(item) {
                this.$router.push({
                    path: '/InfoDetails',
                    query: {
                        id: item.id,
                        type: 'see'
                    }
                })
            },
            /**
             * 获得参数
             */
            getParams() {
                this.type = this.$route.query.type
                this.getList()
            }
        },
        created() {
            this.getParams()
        },
        watch: {
            '$route.query.type': {
                deep: true,
                handler: function (newVal) {
                    this.type = newVal
                    this.getList()
                }
            }
        }
    }
</script>

<style scoped lang="less">
    #Strategy {
        width: 100%;
        background: rgba(244, 244, 244, 1);
        padding-bottom: 60px;

        nav {
            background: white;
            width: 100%;
            height: 58px;

            .nav-box {
                width: 1200px;
                margin: 0 auto;
                height: 58px;
                display: flex;

                .nav-item {
                    height: 58px;
                    line-height: 58px;
                    cursor: pointer;
                    display: block;

                    span:nth-of-type(1) {
                        width: 56px;
                        display: inline-block;
                        height: 58px;
                    }

                    span:nth-of-type(2) {
                        margin: 0 35px;
                        color: #ccc;
                    }
                }

                .nav-item-focus {
                    color: #05A082;

                    span:nth-of-type(1) {
                        display: inline-block;
                        border-bottom: 1px solid #05A082;
                        height: 58px;
                    }
                }
            }
        }

        .strategy-content {
            width: 1200px;
            margin: 0 auto;

            .strategy-item {
                margin: 23px calc(128px / 3) 0 0;
                width: 268px;
                display: inline-block;
                height: 326px;
                background: rgba(255, 255, 255, 1);
                border-radius: 4px;

                &:nth-of-type(4n) {
                    /*margin: 0 0 0 32px;*/
                    margin-right: 0;
                }

                .strategy-banner {
                    width: 100%;
                    height: 176px;
                    overflow: hidden;

                    > img {
                        width: 100%;
                        /*height: 100%;*/
                        transition: all .5s;
                        &:hover {
                            transform: scale(1.4);
                        }
                    }
                }
                .strategy-info {
                    width: 90%;
                    margin: 0 auto;
                    height: 100px;
                    padding-top: 15px;
                    box-sizing: border-box;

                    .strategy-info-content {
                        height: 36px;
                        line-height: 18px;
                        margin: 0 auto;
                        overflow: hidden;
                    }

                    > div:nth-of-type(2) {
                        margin: 20px auto;
                        display: flex;
                        align-items: center;

                        > span {
                            display: flex;
                            align-items: center;
                            margin-right: 20px;
                        }
                    }
                }

                .divider {
                    height: 1px;
                    width: 100%;
                    background: rgba(238, 238, 238, 1);
                }

                .strategy-user {
                    display: flex;
                    align-items: center;
                    height: 45px;

                    > span {
                        margin-right: 10px;
                    }
                }
            }

            .pagination {
                margin: 54px auto 0;
                width: 1200px;
                /*display: flex;*/
                /*justify-content: center;*/
                text-align: center;

                &:after {
                    background: red;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/strategy/Strategy.vue